'use client';

import { useEffect } from 'react';

import { TERMLY_WEBSITE_UUID } from '@m/config/env';
import { useFeatureGate } from '@m/hooks/data/featureFlags';

export const TERMLY_COOKIE_BANNER_GATE = 'termly_cookie_banner';

const TERMLY_SCRIPT_ID = 'termly-resource-blocker';

export default function TermlyCookieBanner() {
  const { data } = useFeatureGate(TERMLY_COOKIE_BANNER_GATE);
  const enabled = data?.enabled === true;

  useEffect(() => {
    if (!enabled || !TERMLY_WEBSITE_UUID) {
      return;
    }
    if (document.getElementById(TERMLY_SCRIPT_ID)) {
      return;
    }

    const script = document.createElement('script');
    script.id = TERMLY_SCRIPT_ID;
    script.type = 'text/javascript';
    script.src = `https://app.termly.io/resource-blocker/${TERMLY_WEBSITE_UUID}?autoBlock=on`;
    script.async = true;
    document.head.appendChild(script);
  }, [enabled]);

  return null;
}
